module.exports = __webpack_public_path__ + "static/media/arrow-right.f4857efa.svg";